import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  
  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Summit App', path: '/summit-app' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="/summit-logo.png" 
              alt="Summit MCG" 
              className="h-16 w-16"
            />
            <div className="ml-3">
              <div className="text-summit-navy-dark font-bold text-xl">Summit MCG</div>
              <div className="text-summit-grey text-xs">Motor Consultancy Group</div>
            </div>
          </Link>
          
          <nav className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === item.path
                    ? 'text-summit-navy-dark border-b-2 border-summit-gold'
                    : 'text-summit-grey hover:text-summit-navy'
                } pb-1`}
              >
                {item.name}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;